import { TabBar } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { DeputateSubjectContainersSubpage } from './DeputateSubjectContainersSubpage';
import { DeputateSubjectGroupsSubpage } from './DeputateSubjectGroupsSubpage';
import { DeputateSubjectsSubpage } from './DeputateSubjectsSubpage';

export const DeputateSetupSubjectsAndSubjectContainer = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <TabBar
        variant='large'
        tabs={[
          {
            trigger: t('subject.title', { count: 2 }),
            id: 'subjects',
            content: <DeputateSubjectsSubpage />,
          },
          {
            trigger: t('subjectContainer.title', { count: 2 }),
            id: 'subjectContainers',
            content: <DeputateSubjectContainersSubpage />,
          },
          {
            trigger: t('subjectGroup.title', { count: 2 }),
            id: 'subjectGroups',
            content: <DeputateSubjectGroupsSubpage />,
          },
        ]}
      />
    </Page>
  );
};
